import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-letter-a",
  "use": "icon-letter-a-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-letter-a\">\n<rect x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n<path d=\"M8.02734 16H9.88477L11.9531 9.23242H12.4688V7.54492H10.9629L8.02734 16ZM9.59766 13.9492H14.373L13.9395 12.625H10.0312L9.59766 13.9492ZM14.1211 16H15.9844L13.043 7.54492H12.0586V9.23242L14.1211 16Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol